import React, { useState } from 'react';
import { Container, Row, Col, Modal, Button } from 'react-bootstrap';

const certificationImages = [
  '/assets/certif1.jpeg',
  '/assets/certif2.jpeg',
  '/assets/certif3.jpeg',
  '/assets/certif4.jpeg',
  '/assets/certif5.jpeg',
  '/assets/certif6.jpeg',
  '/assets/certif7.jpeg',
];

function Certification() {
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);

  const handleShow = (index) => {
    setCurrentIndex(index);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? certificationImages.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === certificationImages.length - 1 ? 0 : prev + 1));
  };

  // Swipe detection handlers
  const handleTouchStart = (e) => setTouchStartX(e.targetTouches[0].clientX);
  const handleTouchEnd = () => {
    if (touchStartX !== null && touchEndX !== null) {
      const diff = touchStartX - touchEndX;
      if (diff > 50) handleNext(); // Swipe left
      else if (diff < -50) handlePrev(); // Swipe right
    }
    setTouchStartX(null);
    setTouchEndX(null);
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: '100vh', paddingTop: '80px' }}
    >
      <Container className="text-center">
        <h2 className="mb-4">Our Certifications</h2>
        <p className="mb-5">Click on an image to view it in full size.</p>

        {Array.from({ length: Math.ceil(certificationImages.length / 3) }).map((_, rowIndex) => (
          <Row key={rowIndex} className="justify-content-center mb-4">
            {certificationImages
              .slice(rowIndex * 3, rowIndex * 3 + 3)
              .map((src, colIndex) => {
                const globalIndex = rowIndex * 3 + colIndex;
                return (
                  <Col key={globalIndex} md={4} className="d-flex justify-content-center mb-3">
                    <img
                      src={src}
                      alt={`Certification ${globalIndex + 1}`}
                      className="img-fluid rounded shadow"
                      style={{ width: '400px', height: '400px', cursor: 'pointer' }}
                      onClick={() => handleShow(globalIndex)}
                    />
                  </Col>
                );
              })}
          </Row>
        ))}

        {/* Modal for popup image view with swipe */}
        <Modal show={showModal} onHide={handleClose} centered size="lg">
          <Modal.Body
            className="text-center"
            onTouchStart={handleTouchStart}
            onTouchMove={(e) => setTouchEndX(e.targetTouches[0].clientX)}
            onTouchEnd={handleTouchEnd}
          >
            <img
              src={certificationImages[currentIndex]}
              alt="Certification Large"
              className="img-fluid"
              style={{ maxHeight: '80vh' }}
            />
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between w-100">
            <Button variant="secondary" onClick={handlePrev}>
              ⬅ Previous
            </Button>
            <Button variant="secondary" onClick={handleNext}>
              Next ➡
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
}

export default Certification;
